import * as tslib_1 from "tslib";
import chart from "./chart";
import loader from "@/components/loader.vue";
import noDataOverlay from "@/components/noDataOverlay.vue";
import { Vue, Component } from "vue-property-decorator";
let widget = class widget extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.activeTab = 0;
    }
    setTab(tab) {
        this.activeTab = tab;
    }
    get noDataAvailable() {
        return true;
    }
};
widget = tslib_1.__decorate([
    Component({
        components: {
            loader,
            chart: chart,
            "no-data": noDataOverlay
        }
    })
], widget);
export default widget;
